import React from "react";
import { Tab, Tabs } from "react-bootstrap";
import { CATEGORIE_COURS_NAVIGATION } from "../../../Routes/NAVIGATION_PATH";
import AllCourses from "./AllCourses/AllCourses";
import CategoryCourses from "./CategoryCourses/CategoryCourses";

function Cours() {
  const filD = {
    nom1: "All courses",
    nom2: "Category courses",
    route1: "",
    route2: CATEGORIE_COURS_NAVIGATION,
  };
  return (
    <div id="coursAdmin" className="pe-3 container">
      <Tabs
        defaultActiveKey="allcours"
        transition={false}
        id="justify-tab-example"
        className="mb-3 fw-bold fs-5"
      >
        <Tab eventKey="allcours" title="Tous les cours">
          <AllCourses />
        </Tab>
        <Tab eventKey="categorie" title="Catégories">
          <CategoryCourses />
        </Tab>
      </Tabs>
    </div>
  );
}

export default Cours;
